import * as yup from "yup";

import { AgentVersionConfigurationInput } from "src/agents/types";

const agentVersionConfigurationSchema = yup.object({
  model_config: yup
    .object({
      model: yup.string().required(),
      system_prompt: yup.string().required(),
      temperature: yup.number().required(),
    })
    .required(),
  tools: yup.array().optional(),
  input_schema: yup.object().nullable().optional(),
  output_schema: yup.object().nullable().optional(),
  execution_config: yup.object().optional(),
  experimental: yup.object().optional(),
});

/**
 * Parses and validates a JSON string against the agent version configuration schema.
 *
 * @throws {SyntaxError} If the input is not valid JSON.
 * @throws {yup.ValidationError} If the parsed JSON does not match the expected schema
 *   (e.g. missing `model_config`, invalid field types).
 */
export const validateAgentVersionConfigurationJson = (
  jsonString: string,
): AgentVersionConfigurationInput => {
  const parsed: unknown = JSON.parse(jsonString);
  return agentVersionConfigurationSchema.validateSync(parsed, {
    strict: true,
  }) as AgentVersionConfigurationInput;
};
